/**
 * Survey Ontology:
 * https://cefriel.github.io/survey-ontology/docs/index.html
 *
 * Workflow Ontology:
 * https://wf4ever.github.io/ro/2016-01-28/wfprov/
 *
 * Provenance Ontology:
 * https://www.w3.org/TR/2013/REC-prov-o-20130430
 */
const ONTOLOGY = {
  SURVEY: `https://w3id.org/survey-ontology#`,
  WORKFLOW: `https://w3id.org/ro/2016-01-28/wfprov#`,
  PROVENANCE: `http://www.w3.org/ns/prov#`,
}

export const URI = {
  CONTAINS: 'http://www.w3.org/ns/ldp#contains',
  STORAGE_PREDICATE: 'http://www.w3.org/ns/pim/space#storage',
  TYPE_PREDICATE: 'http://www.w3.org/1999/02/22-rdf-syntax-ns#type',
  SURVEY_CLASS: `${ONTOLOGY.SURVEY}SurveyProcedure`,
  SURVEY_ANSWER_CLASS: `${ONTOLOGY.SURVEY}Answer`,
  SURVEY_OPEN_ANSWER_CLASS: `${ONTOLOGY.SURVEY}OpenAnswer`,
  SURVEY_SURVEY_ELEMENT_CLASS: `${ONTOLOGY.SURVEY}SurveyElement`,
  SURVEY_SINGLE_INPUT_QUESTION_CLASS: `${ONTOLOGY.SURVEY}SingleInputQuestion`,
  SURVEY_STARTS_WITH_PREDICATE: `${ONTOLOGY.SURVEY}startsWith`,
  SURVEY_STATUS_PREDICATE: `${ONTOLOGY.SURVEY}hasStatus`,
  SURVEY_HAS_TEXT_PREDICATE: `${ONTOLOGY.SURVEY}hasText`,
  SURVEY_LEADS_TO_PREDICATE: `${ONTOLOGY.SURVEY}leadsTo`,
  SURVEY_COMPLETED_QUESTION_CLASS: `${ONTOLOGY.SURVEY}CompletedQuestion`,
  SURVEY_HAS_ANSWER_PREDICATE: `${ONTOLOGY.SURVEY}hasAnswer`,
  SURVEY_HAS_ANSWER_TEXT_PREDICATE: `${ONTOLOGY.SURVEY}hasAnswerText`,
  SURVEY_COMPLETES_QUESTION_PREDICATE: `${ONTOLOGY.SURVEY}completesQuestion`,
  SURVEY_HAS_COMPLETION_TIMESTAMP_PREDICATE: `${ONTOLOGY.SURVEY}hasCompletionTimestamp`,
  SURVEY_COMPLETION_TASK_CLASS: `${ONTOLOGY.SURVEY}SurveyCompletionTask`,
  SURVEY_SESSION_ID_PREDICATE: `${ONTOLOGY.SURVEY}sessionId`,
  WORKFLOW_PROCESS_RUN_CLASS: `${ONTOLOGY.WORKFLOW}ProcessRun`,
  PROVENANCE_ACTIVITY_STARTED_AT: `${ONTOLOGY.PROVENANCE}startedAtTime`,
  PROVENANCE_ACTIVITY_ENDED_AT: `${ONTOLOGY.PROVENANCE}endedAtTime`,
}
